import { type ReactNode } from 'react';

import { floatingOverlayPortalSystem } from './FloatingOverlayPortalContext';

interface FloatingOverlayPortalProps {
  children: ReactNode;
}

/**
 * FloatingOverlayPortal — renders children into the FloatingOverlayHost container.
 */
export function FloatingOverlayPortal({ children }: FloatingOverlayPortalProps) {
  const PortalComponent = floatingOverlayPortalSystem.Portal;
  return <PortalComponent>{children}</PortalComponent>;
}
